import { defineStore } from "pinia";
import type { PesawatReport,ReportDetailPesawat,DomesticAirports,Internationalairports,AirlinesCode,schedulePlaneReq,getFaresReq,airlinesBookingReq,RefundReq,RebookSchReq,CreateRebook,createPaymentRequest,listPayments,createPaymentResponse,confirmRefund,WebCheckin,AirlinesSchedules,multyCityReq,airlineList } from "~/istypes";
import { useUserStore} from "~/stores/user";
import airportAliases from '~/data/airport_aliases.json';
import airlines from '~/data/maskapai_name.json';

export const useAirlinesStore = defineStore('airlines', () => {
    const config = useRuntimeConfig();
    const userStore = useUserStore();

    const saveToLocalStorage = (key: string, data: any) => {
        localStorage.setItem(key, JSON.stringify(data));
    };

    const getAirlineName = (code: string) => {
        const airline = airlines.find(a => a.iata_code === code);
       return airline ? airline.full_name : 'Unknown Airline';
    }

    const getReport= async (start_date?: Date | null, end_date?: Date | null) => {
        if (userStore.token) {
            try {
                const res = await $fetch<PesawatReport>(`${config.public.ApiBase}/airlines/reports`, {
                    method: "POST",
                    body: {
                        tm: 1,
                        start_date: start_date,
                        end_date: end_date,
                    },
                    headers: {
                        Authorization: `Bearer ${userStore.token}`,
                        "Device-Id": userStore.deviceId(),                    }
                });

                return res;
            } catch (error) {
                return error;
            }
        }
    }

    const getReportDetail = async (id: string) => {
        if (userStore.token) {
            try {
                const res = await $fetch<ReportDetailPesawat>(`${config.public.ApiBase}/airlines/reports/detail`, {
                    method: "POST",
                    body: { transaction_id: id },
                    headers: {
                        Authorization: `Bearer ${userStore.token}`,
                        "Device-Id": userStore.deviceId(),                    }
                });

                return res;
            } catch (error) {
                return error;
            }
        }
    }

    const getDomesticAirport = async () => {
        try {
            const res = await $fetch<DomesticAirports>(`${config.public.ApiRest}airports/domestic`, {
                method: "GET",
                headers:{
                    "Device-Id": userStore.deviceId(),
                }
            });

            return res;
        } catch (error) {
            console.error("Error fetching:", error);
        }
        
    }

    const getInternationalAirport = async () => {
        try {
            const res = await $fetch<Internationalairports>(`${config.public.ApiRest}airports/international`, {
                method: "GET",
                headers:{
                    "Device-Id": userStore.deviceId(),
                }
            });

            const airportsWithAlias = res.map((airport: { id: string | number; }) => {
                const aliasData = airportAliases.find(item => item.iata === airport.id);


                return {
                    ...airport,
                    alias: aliasData ? aliasData.alias : "No Alias Found"
                };
            });
            // console.log(airportAliases); 
    
            return airportsWithAlias;

        } catch (error) {
            console.error("Error fetching:", error);
        }
        
    }

    const getAirlinesCode = async () => {
        try {
            const res = await $fetch<AirlinesCode>(`${config.public.ApiRest}airports/airlines_codes`, {
                method: "GET",
                headers:{
                    "Device-Id": userStore.deviceId(),
                }
            });

            return res;
        } catch (error) {
            console.error("Error fetching:", error);
        }
        
    }

    const getSchedule = async (data: schedulePlaneReq) => {
        const headers: Record<string, string> = {};

        headers["Device-Id"] = userStore.deviceId();
        
        if (userStore.token) {
            headers.Authorization = `Bearer ${userStore.token}`;
        }

        try {
            const res = await $fetch<any>(`${config.public.ApiBase}/airlines/get_schedule`, {
                method: "POST",
                body: data,
                headers
            });

            // if(res.status?.code == 200){
            //     saveToLocalStorage('airlinesReq',data);
            //     saveToLocalStorage('scheduleAirline', res);
            // }

            return res;
        } catch (error) {
            return error;
        }
    }

    const getFares = async (data: getFaresReq) => {
        if (userStore.token) {
            try {
                const res = await $fetch<any>(`${config.public.ApiBase}/airlines/get_fare`, {
                    method: "POST",
                    body: data,
                    headers: {
                        Authorization: `Bearer ${userStore.token}`,
                        "Device-Id": userStore.deviceId(),                    
                    }
                });
                
                return res;
            } catch (error) {
                return error;
            }
        }
    }

    const booking = async(data: airlinesBookingReq) => {
        if(userStore.token){
            try{
                const res = await $fetch<any>(`${config.public.ApiBase}/airlines/booking`, {
                    method: "POST",
                    body: data,
                    headers: {
                        Authorization: `Bearer ${userStore.token}`,
                        "Device-Id": userStore.deviceId(),                    
                    }
                });

                return res;

            }catch(error){
                return error
            }
        }
    }

    const createRefund = async(data: RefundReq) =>{
        if(userStore.token){
            try{
                const res = await $fetch<any>(`${config.public.ApiBase}/airlines/refund`, {
                    method: "POST",
                    body: data,
                    headers: {
                        Authorization: `Bearer ${userStore.token}`,
                        "Device-Id": userStore.deviceId(),                    
                    }
                });

                return res;

            }catch(error){
                return error
            }
        }
    }

    const confirmRefund = async(data: confirmRefund) => {
        if(userStore.token){
            try{
                const res = await $fetch<any>(`${config.public.ApiBase}/airlines/refund/confirmed`, {
                    method: "POST",
                    body: data,
                    headers: {
                        Authorization: `Bearer ${userStore.token}`,
                        "Device-Id": userStore.deviceId(),                    
                    }
                });

                return res;

            }catch(error){
                return error
            }
        }
    }

    const refundReport = async(start_date: any,end_date: any) => {
        if (userStore.token) {
            try {
                const res = await $fetch<PesawatReport>(`${config.public.ApiBase}/airlines/refund/reports`, {
                    method: "POST",
                    body: {
                        start_date: start_date,
                        end_date: end_date,
                    },
                    headers: {
                        Authorization: `Bearer ${userStore.token}`,
                        "Device-Id": userStore.deviceId(),                    
                    }
                });

                return res;
            } catch (error) {
                return error;
            }
        }
    }

    const refundDetailReport = async(refund_id: any) => {
        if (userStore.token) {
            try {
                const res = await $fetch<PesawatReport>(`${config.public.ApiBase}/airlines/refund/reports/detail`, {
                    method: "POST",
                    body:{
                        refund_id:refund_id
                    },
                    headers: {
                        Authorization: `Bearer ${userStore.token}`,
                        "Device-Id": userStore.deviceId(),                    
                    }
                });

                return res;
            } catch (error) {
                return error;
            }
        }
    }


    const getScheduleRebook = async(data: RebookSchReq) => {
        if(userStore.token){
            try{
                const res = await $fetch<any>(`${config.public.ApiBase}/airlines/rebook/get_schedule`, {
                    method: "POST",
                    body: data,
                    headers: {
                        Authorization: `Bearer ${userStore.token}`,
                        "Device-Id": userStore.deviceId(),                    
                    }
                });

                return res;

            }catch(error){
                return error
            }
        }
    }

    const createRebook = async(data: CreateRebook) => {
        if(userStore.token){
            try{
                const res = await $fetch<any>(`${config.public.ApiBase}/airlines/rebook`, {
                    method: "POST",
                    body: data,
                    headers: {
                        Authorization: `Bearer ${userStore.token}`,
                        "Device-Id": userStore.deviceId(),                   
                    }
                });

                return res;

            }catch(error){
                return error
            }
        }
    }


    const confirmRebook = async(data: any) => {
        if(userStore.token){
            try{
                const res = await $fetch<any>(`${config.public.ApiBase}/airlines/rebook/confirmed`, {
                    method: "POST",
                    body:data,
                    headers: {
                        Authorization: `Bearer ${userStore.token}`,
                        "Device-Id": userStore.deviceId(),  
                    }
                });

                return res;

            }catch(error){
                return error
            }
        }
    }

    const rebookReport = async(start_date: any,end_date: any) => {
        if (userStore.token) {
            try {
                const res = await $fetch<PesawatReport>(`${config.public.ApiBase}/airlines/rebook/reports`, {
                    method: "POST",
                    body: {
                        start_date: start_date,
                        end_date: end_date,
                    },
                    headers: {
                        Authorization: `Bearer ${userStore.token}`,
                        "Device-Id": userStore.deviceId(),                    
                    }
                });

                return res;
            } catch (error) {
                return error;
            }
        }
    }

    const rebookDetailReport = async(rebook_id: any) => {
        if (userStore.token) {
            try {
                const res = await $fetch<PesawatReport>(`${config.public.ApiBase}/airlines/rebook/reports/detail`, {
                    method: "POST",
                    body:{
                        rebook_id:rebook_id
                    },
                    headers: {
                        Authorization: `Bearer ${userStore.token}`,
                        "Device-Id": userStore.deviceId(),                    
                    }
                });

                return res;
            } catch (error) {
                return error;
            }
        }
    }


    const cancelBooking = async(id: any) => {
        if (userStore.token) {
            try {
                const res = await $fetch<any>(`${config.public.ApiBase}/airlines/cancel_booking`, {
                    method: "POST",
                    body:{
                        transaction_id:id
                    },
                    headers: {
                        Authorization: `Bearer ${userStore.token}`,
                        "Device-Id": userStore.deviceId(),                    
                    }
                });

                return res;
            } catch (error) {
                return error;
            }
        }
    }


    const getListPayments = async (id: number | string) => {
        if(userStore.token){
            try {
                const res = await $fetch<listPayments>(`${config.public.ApiBase}/airlines/payments`, {
                    method: "POST",
                    body: { transaction_id: id },
                    headers: {
                        Authorization: `Bearer ${userStore.token}`,
                        "Device-Id": userStore.deviceId(),                    
                    }
                });

                return res;
            } catch (error) {
                return error;
            }
        }
    }

    const createPayment = async (data: createPaymentRequest) => {
        if(userStore.token){
            try {
                const res = await $fetch<createPaymentResponse>(`${config.public.ApiBase}/payments/create`, {
                    method: "POST",
                    body: data,
                    headers: {
                        Authorization: `Bearer ${userStore.token}`,
                        "Device-Id": userStore.deviceId(),                   
                    }
                });

                return res;
            } catch (error) {
                return error;
            }
        }
    }

    const getWebCheckin = async () => {
        try {
            const response = await $fetch<WebCheckin>(`${config.public.ApiRest}checkin_airlines_v2`, {
                method: "GET",
            });

            return response;
        } catch (error) {
            console.error("Error get web checkin:", error);
        }
    }

    const getScheduleMultiCity = async (data: multyCityReq) => {
        const headers: Record<string, string> = {};

        headers["Device-Id"] = userStore.deviceId();
        
        if (userStore.token) {
            headers.Authorization = `Bearer ${userStore.token}`;
        }
        try{
            const res = await $fetch<AirlinesSchedules>(`${config.public.ApiBase}/airlines/multicity/get_schedule`, {
                method: "POST",
                body: data,
                headers: {
                    Authorization: `Bearer ${userStore.token}`,
                    "Device-Id": userStore.deviceId(),                   
                }
            }); 
            return res;
        }catch(error){
            return error
        }
    }

    const getFaresMultiCity = async (data: multyCityReq) => {
        if(userStore.token){
            try{
                const res = await $fetch<any>(`${config.public.ApiBase}/airlines/multicity/get_fare`, {
                    method: "POST",
                    body: data,
                    headers: {
                        Authorization: `Bearer ${userStore.token}`,
                        "Device-Id": userStore.deviceId(),                   
                    }
                }); 
                return res;
            }catch(error){
                return error
            }
        }
    }

    const bookingMulticity = async(data: airlinesBookingReq) => {
        if(userStore.token){
            try{
                const res = await $fetch<any>(`${config.public.ApiBase}/airlines/multicity/booking`, {
                    method: "POST",
                    body: data,
                    headers: {
                        Authorization: `Bearer ${userStore.token}`,
                        "Device-Id": userStore.deviceId(),                    
                    }
                });

                return res;

            }catch(error){
                return error
            }
        }
    }

    const shareItenerarry = async(id: number)  => {
        if(userStore.token){
            try{
                const response = await $fetch<any>(`${config.public.mainDomain}/airlines/receipt/${id}`, {
                    method: "GET",
                    responseType: 'blob'
                    // headers: {
                    //     Authorization: `Bearer ${userStore.token}`,
                    //     "Device-Id": userStore.deviceId(),                   
                    // }
                }); 

                // return response
                // Membuat Blob dari response dan mengubahnya menjadi base64
                const blob = new Blob([response], { type: 'application/pdf' });
                const reader = new FileReader();

                reader.onloadend = () => {
                    const base64data = reader.result as string;

                    // Kirim base64 data ke WhatsApp
                    const waMessage = `Lihat laporan PDF berikut:`;
                    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(waMessage)}&attachment=${base64data}`;
                    window.open(whatsappUrl, '_blank');
                };

                reader.readAsDataURL(blob); // Konversi Blob menjadi Base64
            }catch(error){
                return error
            }
        }
    }

    const extractFirstAndLastName = (fullname: string): [string, string] => {
        const parts = fullname.trim().split(" ").filter(Boolean);
        let fn = "";
        let ln = "";
      
        if (parts.length === 1) {
          fn = ln = parts[0];
        } else if (parts.length === 2) {
          fn = parts[0].length > 1 ? parts[0] : `${parts[0]} ${parts[1]}`;
          ln = parts[1].length > 1 ? parts[1] : `${parts[0]} ${parts[1]}`;
        } else if (parts.length > 2) {
          const lastIndex = parts.length - 1;
          const isLastNameSingleChar = parts[lastIndex].length === 1;
      
          ln = isLastNameSingleChar
            ? `${parts[lastIndex - 1]} ${parts[lastIndex]}`
            : parts[lastIndex];
      
          fn = parts
            .slice(0, isLastNameSingleChar ? lastIndex - 1 : lastIndex)
            .join(" ");
        }
      
        return [fn, ln];
      }
      

    return { getReport,getReportDetail,getDomesticAirport,
        getInternationalAirport,getAirlinesCode,getSchedule,getFares
        ,booking,createRefund,confirmRefund,refundReport,refundDetailReport,
        getScheduleRebook,createRebook,confirmRebook,rebookReport,rebookDetailReport,
        cancelBooking,getListPayments,createPayment,getWebCheckin,getScheduleMultiCity,
        getFaresMultiCity,bookingMulticity,shareItenerarry,getAirlineName,extractFirstAndLastName};
});